import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../lib/api';
import { Instagram } from 'lucide-react';
import insta1 from '../assets/images/home/insta-1.jpg';
import insta2 from '../assets/images/home/insta-2.jpg';
import insta3 from '../assets/images/home/insta-3.jpg';
import insta4 from '../assets/images/home/insta-4.jpg';
import insta5 from '../assets/images/home/insta-5.jpg';
import insta6 from '../assets/images/home/insta-6.jpg';

// Fallback grid, shown until the live posts load or if the Instagram feed is
// unavailable (no token configured on the backend, network error, etc.).
const POSTS = [
  { image: insta1, href: 'https://instagram.com/houseofseya.in' },
  { image: insta2, href: 'https://instagram.com/houseofseya.in' },
  { image: insta3, href: 'https://instagram.com/houseofseya.in' },
  { image: insta4, href: 'https://instagram.com/houseofseya.in' },
  { image: insta5, href: 'https://instagram.com/houseofseya.in' },
  { image: insta6, href: 'https://instagram.com/houseofseya.in' },
];

const InstagramFeed = () => {
  const [posts, setPosts] = useState(POSTS);

  // Latest 6 posts from @houseofseya.in, fetched through our backend (the
  // Instagram token must stay server-side).
  useEffect(() => {
    let isMounted = true;
    fetch(`${getApiUrl()}/instagram`)
      .then(res => res.json())
      .then(json => {
        const live = json?.data?.posts;
        if (isMounted && Array.isArray(live) && live.length >= 6) setPosts(live.slice(0, 6));
      })
      .catch(() => {});
    return () => { isMounted = false; };
  }, []);

  return (
  <section className="py-8 lg:py-10 bg-[#FFFFFF]">
    <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
      <div className="text-center mb-10">
        <h2 className="font-serif text-3xl lg:text-4xl text-[#1a1a1a] flex items-center justify-center gap-3 whitespace-nowrap">
          <Instagram size={22} strokeWidth={1.4} className="flex-shrink-0" /> @houseofseya.in
        </h2>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 lg:gap-3">
        {posts.map((p, i) => (
          <a key={i} href={p.href} target="_blank" rel="noopener noreferrer" className="group block aspect-square overflow-hidden bg-[#FFFFFF]">
            <img src={p.image} alt="Instagram post" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
          </a>
        ))}
      </div>
    </div>
  </section>
  );
};

export default InstagramFeed;
